import { Component } from '@angular/core';

@Component({
  selector: 'app-error-camera',
  templateUrl: './error-camera.component.html',
  styleUrls: ['./error-camera.component.scss']
})
export class ErrorCameraComponent {

}
